import './App.css';
import { ConfigProvider } from 'antd';
import { customDarkTheme, customDefaultTheme } from './theme/customTheme';
import {  useEffect, useState } from 'react';
import RoutesApp from './routes';
function App() {

  const [theme, setTheme] = useState("default");

  useEffect(()=>{
    const profileTheme = localStorage.getItem('profileTheme');
    if(profileTheme){
      setTheme(profileTheme)
    }
  },[])

  return (
     <ConfigProvider theme={theme === "default" ? customDefaultTheme : customDarkTheme}>
      {/* <ConfigProvider theme={customDarkTheme}> */}
        <RoutesApp sendTheme = {setTheme} getTheme = {theme} />
      </ConfigProvider>
  );
}

export default App;